import axios from 'axios'

const apiUrl = 'https://##API_URL##'
// const apiUrl = 'https://app.stg.internal.qualif.io'
// const apiUrl = '//192.168.40.135:3000'
// const apiUrl = '//127.0.0.1:3000'

export const getChartData = (requestInfo) => {
  const { clientId, campaignId, channelId, questionId, participationId } = requestInfo
  const partId = participationId ? `&participationId=${participationId}` : ''

  return axios
    .get(`${apiUrl}/v1/charts/?clientId=${clientId}&campaignId=${campaignId}&channelId=${channelId}&questionId=${questionId}${partId}`,
      {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
}

export const getPersonalityChartData = (requestInfo) => {
  const { clientId, campaignId, channelId, questions, participationId } = requestInfo
  const partId = participationId ? `&participationId=${participationId}` : ''

  return axios
    .get(`${apiUrl}/v1/charts/personality-tests?clientId=${clientId}&campaignId=${campaignId}&channelId=${channelId}&questions=${questions}${partId}`,
      {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
}



// WEBPACK FOOTER //
// ./src/helpers/http.js